import React, {Component} from 'react';
import {RTLTable, RTLCol, RTLButton} from '../RTLKit';
import {Divider, Row,  Pagination} from 'antd';
import {reduxForm} from "redux-form";

import Loading from '../loading/loading';

const columns = [
    {
        title: 'ردیف',
        dataIndex: 'key',
        sorter: (a, b) => a.key - b.key,
        width:'10%'
    },
    {
        title: 'استان',
        dataIndex: 'state',
        width:"20%"
    },
    {
        title: 'تعداد',
        dataIndex: 'count',
    }
  ];

const userColumns = [
    {
        title: 'ردیف',
        dataIndex: 'key',
        sorter: (a, b) => a.key - b.key,
        width:'10%'
    },
    {
        title: 'نام تکنسین',
        dataIndex: 'name',
        width:"20%"
    },
    {
        title: 'تعداد',
        dataIndex: 'count',
    }
  ];


class WarehouseList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            role:'',
            searchBoxHidden:true, //hidden=true
            loading:true,
            pageSize:10,
            current: (this.props.list ? this.props.list.pageNumber : 1),
            pageTitle: null
        }

        this.__onChangeCounter = this.__onChangeCounter.bind(this)

    }

    componentWillMount() {
        let param = []
        let id = this.props.match.params.id
        if(this.props.match.params.id){
            let id = this.props.match.params.id
            this.props.getItem(id);
        }
    }

    /*--- pagination ---*/
    handlePageChange(pageNumber) {
        this.setState({current: pageNumber});
        let id = this.props.match.params.id
        if(this.props.initialValues){
            this.props.initialValues.state_inventory = this.props.initialValues.state_inventory;
        }

    }

    /*--- fix user list for show in table ---*/
    __fixListForShowInTable() {
        let stateInventory;
        if(this.props.initialValues)
            stateInventory = this.props.initialValues.state_inventory;
        let dataSource = [];

        if (stateInventory) {

            for (let i = 0; i < stateInventory.length; i++) {

                dataSource.push({
                    key: (i+1),
                    state : stateInventory[i].title,
                    count : stateInventory[i].inventory
                });

            }

        }

        return dataSource;
    }

    __fixTechniciantForShowInTable() {
        let technicianInventory
        if(this.props.initialValues)
            technicianInventory = this.props.initialValues.technician_inventory;
        let dataSource = [];

        if (technicianInventory) {

            for (let i = 0; i < technicianInventory.length; i++) {

                dataSource.push({
                    key: (i+1),
                    name : technicianInventory[i].name+' '+technicianInventory[i].family,
                    count : technicianInventory[i].inventory,
                });

            }

        }

        return dataSource;
    }

    __toggleSearchBox(){
        this.setState({
            searchBoxHidden : !this.state.searchBoxHidden
        })
    }

    __onChangeCounter(value) {
        this.setState({
            pageSize:value
        })
    }

    __goBack(){
        this.props.history.goBack()
    }

    render() {
        var _self = this;
        const {pageSize } = this.state;
        const { initialValues } = this.props;
        let product_title;
        let centralInventory;

        if(initialValues) {
            product_title = initialValues.product_title
            centralInventory = initialValues.center_inventory
        }

        return (
            <div>
                <Row type="flex">
                    <RTLCol xs={24} md={24}>
                        <Divider orientation="left">موجودی انبار برای محصول {product_title}</Divider>
                    </RTLCol>
                </Row>
                <Row>
                    <label className="right">انبار مرکزی : </label>
                    <div className="right">
                        {centralInventory}
                    </div>
                    <Loading list={initialValues} />
                </Row>
                <Divider orientation="left">موجودی انبار استان ها </Divider>
                <Row>
                    <RTLTable rowClassName={(record, index) => (index+1)%2 == 0 ? 'even' : 'odd' } pagination={false} columns={columns} dataSource={this.__fixListForShowInTable()} size="small" />
                </Row>
                <Divider orientation="left">موجودی انبار تکنسین ها </Divider>
                <Row>
                    <RTLTable rowClassName={(record, index) => (index+1)%2 == 0 ? 'even' : 'odd' } pagination={false} columns={userColumns} dataSource={this.__fixTechniciantForShowInTable()} size="small" />
                </Row>
            </div>
        );
    }
}

export default WarehouseList = reduxForm({
    form: 'list'
})(WarehouseList)
